<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <div class="place-search-map">
    <vue-daum-map
      :appKey="appKey"
      :center="center"
      :level.sync="level"
      :mapTypeId="mapTypeId"
      :libraries="libraries"
      :style="{width:'100%', height: '100%'}"
      v-if="center.lat && center.lng"
      @load="loadMaps"
    >
    </vue-daum-map>
    <div class="map-overlay" @click="removeOverlay" v-if="isShowOverlay">
      <span>클릭하시면 지도를 움직이실 수 있습니다.</span>
    </div>
  </div>
</template>

<script>
  import VueDaumMap from 'vue-daum-map'
  import MapConstant from '../../const/maps'
  import mapApi from '../../api/maps'
  import packageMarkerImage from '../../assets/images/ex-p.png'

  import resMarker from '../../assets/images/ex-res-small.png'
  import cafeMarker from '../../assets/images/ex-cafe-small.png'
  import expMarker from '../../assets/images/ex-exp-small.png'
  import subMarker from '../../assets/images/ex-sub-small.png'
  import bankMarker from '../../assets/images/ex-bank-small.png'

  export default {
    name: 'PlaceSearchMap',
    components: {
      VueDaumMap
    },
    props: {
      lat: {
        type: Number,
        default: undefined
      },
      lng: {
        type: Number,
        default: undefined
      },
      center: {
        type: Object,
        default: () => {
          return {
            lat: undefined,
            lng: undefined
          }
        }
      },
      category: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        appKey: MapConstant.APP_KEY,
        level: 3,
        mapTypeId: MapConstant.MAP_TYPE,
        libraries: MapConstant.LIBRARIES,
        map: undefined,
        myMarker: undefined,
        isShowOverlay: true,
        placeList: undefined,
        placeMarkerList: []
      }
    },
    watch: {
      center: {
        handler () {
          // console.log(newVal)
          // this.center = newVal
          this.drawSelf()
          this.searchPlaces()
        },
        deep: true
      },
      category () {
        this.searchPlaces()
      }
    },
    methods: {
      loadMaps (context) {
        this.map = context
        this.drawSelf()
        this.searchPlaces()
      },

      getBounds () {
        if (this.map) {
          // 지도의 현재 영역을 얻어옵니다
          const bounds = this.map.getBounds()

          // 영역의 남서쪽 좌표를 얻어옵니다
          const swLatLng = bounds.getSouthWest()

          // 영역의 북동쪽 좌표를 얻어옵니다
          const neLatLng = bounds.getNorthEast()

          return {
            swLatLng,
            neLatLng
          }
        }
      },
      // 카테고리 검색을 요청하는 함수입니다
      async searchPlaces () {
        try {
          if (this.map) {
            const {swLatLng, neLatLng} = this.getBounds()
            const coordinate = [swLatLng.getLng(), swLatLng.getLat(), neLatLng.getLng(), neLatLng.getLat()]
            const placeResult = await mapApi.searchByNearPlace({
              coordinate,
              query: this.category,
              center: `${this.center.lat},${this.center.lng}`
            })
            this.placeList = placeResult.data.result
            this.drawPlace()
          }
        } catch (error) {
          console.error(error)
        }
      },
      drawSelf () {
        const imageSrc = packageMarkerImage
        const imageSize = new this.daum.maps.Size(35, 47) // 마커이미지의 크기입니다

        const imageOption = {offset: new this.daum.maps.Point(20, 20)} // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.
        const markerImageObj = new this.daum.maps.MarkerImage(imageSrc, imageSize, imageOption)

        const location = [this.center.lat, this.center.lng]
        const position = new this.daum.maps.LatLng(location[0], location[1])
        const marker = new this.daum.maps.Marker({
          map: this.map,
          position: position,
          clickable: true,
          image: markerImageObj
        })

        this.myMarker = marker
      },
      // MARKER
      getMarkerImage () {
        let image
        switch (this.category) {
        case 'FD6':
          image = resMarker
          break
        case 'CE7':
          image =  cafeMarker
          break
        case 'CS2':
          image =  expMarker
          break
        case 'SW8':
          image =  subMarker
          break
        case 'BK9':
          image =  bankMarker
          break
        }

        const imageSize = new this.daum.maps.Size(31, 31) // 마커이미지의 크기입니다

        const imageOption = {offset: new this.daum.maps.Point(10, 10)} // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.
        return new this.daum.maps.MarkerImage(image, imageSize, imageOption)
      },

      drawPlace () {
        this.removePlace()
        const documents = this.placeList.documents

        documents.map(document => {
          const markerImageObj = this.getMarkerImage()

          const location = [document.y, document.x]
          const position = new this.daum.maps.LatLng(location[0], location[1])
          const marker = new this.daum.maps.Marker({
            map: this.map,
            position: position,
            clickable: true,
            image: markerImageObj
          })
          this.placeMarkerList.push(marker)
        })
      },
      removePlace() {
        this.placeMarkerList.map(placeMarker => {
          placeMarker.setMap(null)
          placeMarker = null
        })

        this.placeMarkerList = []
      },
      removeOverlay () {
        this.isShowOverlay = false
      }
    }
  }
</script>

<style scoped lang="less">
  .place-search-map{
    width: 100%;
    height: 100%;
    position: relative;
  }

  .map-overlay {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: rgba(0,0,0,0.5);
    text-align: center;
    vertical-align: middle;
    line-height: 40rem;
    color: white;
  }

</style>
